// =============================================================================
// Back-office: convenio
// =============================================================================
import { apiClient } from './http';

/**
 * Convenio. `legal_*` son los topes del Estatuto: la UI los enseña, no los
 * negocia. `clamped` dice qué acaba de recortar el backend para poder
 * explicárselo al admin en vez de tragárselo en silencio.
 */
export interface WorkPolicyView {
  id: number;
  name: string;
  is_default: boolean;
  // null = la jurisdicción (y el convenio) no fijan tope de extra: el
  // backend lo sirve tal cual y PolicyAdmin lo pinta como campo vacío. El
  // tipo `number` a secas invitaba a `policy.max_overtime_annual + 1` al
  // siguiente consumidor — NaN silencioso en un tenant sin tope, el caso
  // que menos se prueba (ronda 4, r2b20[8]).
  max_overtime_annual: number | null;
  vacation_days_annual: number;
  standard_daily_hours: number;
  annual_hours: number;
  entry_tolerance_minutes: number;
  night_start: string;
  night_end: string;
  lunch_auto_deduct: boolean;
  lunch_threshold_hours: number;
  lunch_deduction_minutes: number;
  legal_max_overtime_annual: number | null;
  legal_min_vacation_days: number;
  legal_max_consecutive_nights: number | null;
  legal_night_start: string;
  legal_night_end: string;
  clamped: string[];
}

export async function getWorkPolicies(): Promise<WorkPolicyView[]> {
  const res = await apiClient.get<WorkPolicyView[]>('/work-policies');
  return res.data;
}

export async function createWorkPolicy(name: string): Promise<WorkPolicyView> {
  const res = await apiClient.post<WorkPolicyView>('/work-policies', { name });
  return res.data;
}

export async function deleteWorkPolicy(id: number): Promise<void> {
  await apiClient.delete(`/work-policies/${id}`);
}

export async function updateWorkPolicy(
  id: number,
  data: Partial<Pick<WorkPolicyView, 'name' | 'annual_hours' | 'max_overtime_annual' | 'vacation_days_annual' | 'standard_daily_hours' | 'entry_tolerance_minutes' | 'night_start' | 'night_end' | 'lunch_auto_deduct' | 'lunch_threshold_hours' | 'lunch_deduction_minutes'>>
): Promise<WorkPolicyView> {
  const res = await apiClient.put<WorkPolicyView>(`/work-policies/${id}`, data);
  return res.data;
}
